"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get BaseReviewForm () {
        return BaseReviewForm;
    },
    get ReviewFormWithDefaultsWithQuestions () {
        return ReviewFormWithDefaultsWithQuestions;
    },
    get ReviewFormWithDefaultsWithoutQuestions () {
        return ReviewFormWithDefaultsWithoutQuestions;
    },
    get ReviewFormWithQuestions () {
        return ReviewFormWithQuestions;
    },
    get ReviewFormWithoutQuestions () {
        return ReviewFormWithoutQuestions;
    }
});
const _zod = require("zod");
const _models = require("@performyard/models");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const _reviewquestion = require("../questions/review-question");
const _reviewformhelper = require("./helpers/review-form-helper");
const BaseReviewForm = _zod.z.object({
    _id: _utilsisomorphic.transformObjectId,
    companyId: _models.ReviewFormModel.shape.company,
    baseId: _models.ReviewFormModel.shape.base_id,
    name: _models.ReviewFormModel.shape.name,
    createdAt: _models.ReviewFormModel.shape.created_at.nullable(),
    createdBy: _models.ReviewFormModel.shape.creator.nullable(),
    updatedAt: _models.ReviewFormModel.shape.updated_at.nullable(),
    updatedBy: _models.ReviewFormModel.shape.updated_by.nullable()
});
const ReviewFormWithoutQuestions = BaseReviewForm.extend({
    questionsCount: _zod.z.number()
});
const ReviewFormWithQuestions = BaseReviewForm.extend({
    questions: _zod.z.array(_reviewquestion.ReviewQuestion)
});
const ReviewFormWithDefaultsWithoutQuestions = _zod.z.preprocess(_reviewformhelper.convertFormModelToServiceContract, ReviewFormWithoutQuestions);
const ReviewFormWithDefaultsWithQuestions = _zod.z.preprocess(_reviewformhelper.convertFormModelToServiceContract, ReviewFormWithQuestions);
